import type { AxiosInstance } from 'axios';
import { handleResponseError } from '../errors/error-handler.ts';
import { handleRequest } from './request.interceptor.ts';

export function setupInterceptors(instance: AxiosInstance) {
  instance.interceptors.request.use(handleRequest, (error: Error) => Promise.reject(error));
  instance.interceptors.response.use(undefined, handleResponseError);
}
